// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';

import ConsentModeSelect from 'app/components/consent-mode-select/ConsentModeSelect';

import useConsentModeEnabled from './useConsentModeEnabled';

/**
 * Consent mode really only needs `consentMode` feature flag, but the entire "configurable consent"
 * feature needs `configurableConsentMvp` and `ecmConfigurableConsent`. Since consent mode
 * is part of "configurable consent", gated behind all three flags.
 *
 * Note there is no fallback component, if one is needed, switch to FeatureGate.
 */
export default function GatedConsentModeSelect({ onChange, ...props }) {
  const { consentModeEnabled } = useConsentModeEnabled();
  if (!consentModeEnabled) return null;

  return <ConsentModeSelect onChange={onChange} {...props} />;
}

GatedConsentModeSelect.propTypes = ConsentModeSelect.propTypes;
